module.exports = __webpack_public_path__ + "static/iimb-e41761fde596cf6f145c751c3b2277b0.png";